import { Navigate } from 'react-router-dom';
export default function PaymentsPage() { return <Navigate to="/checkout" replace />; }
